// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"assets_i18n_en_translation_json":"dfe1e44a024c22895198","assets_i18n_nl_translation_json":"30b3e090d6938625ae31"}[chunkId] + ".chunk.js";
};